import './HomePage.css';
import Ambient from '../components/Ambient';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import GameWorlds from '../components/GameWorlds';
import Families from '../components/Families';
import CallToAction from '../components/CallToAction';
import SEO from '../components/SEO';

const HomePage = () => (
  <>
    <SEO
      title="Sprout Academy | Learning Through Adventure"
      description="Sprout Academy is a story-led learning game for ages 5-8, aligned to the UK National Curriculum with parent-friendly progress updates."
      path="/"
    />
    <Ambient />
    <header className="hero" id="top">
      <Hero />
    </header>
    <HowItWorks />
    <GameWorlds />
    <Families />
    <CallToAction />
  </>
);

export default HomePage;
